export const calculateEffectiveYears = (item) => {
  // 优先 originalAt
  if (item.originalAt) {
    if (
      item.expiredAt &&
      new Date(item.originalAt).getTime() !== new Date(item.expiredAt).getTime()
    ) {
      return Math.round(
        Math.abs(new Date(item.expiredAt).getTime() - new Date(item.originalAt).getTime()) /
          (1000 * 60 * 60 * 24 * 365),
      );
    }
    return '-';
  }
  // originalAt 没有值，判断 createdAt 和 expiredAt
  if (
    item.createdAt &&
    item.expiredAt &&
    new Date(item.createdAt).getTime() !== new Date(item.expiredAt).getTime()
  ) {
    return Math.round(
      Math.abs(new Date(item.expiredAt).getTime() - new Date(item.createdAt).getTime()) /
        (1000 * 60 * 60 * 24 * 365),
    );
  }
  return '-';
};

export default calculateEffectiveYears;
